import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FiMenu, FiX } from 'react-icons/fi';
import NavigationLink from './NavigationLink';
import RentalButton from './RentalButton';
import MobileMenu from './MobileMenu';
import { navigationLinks } from './navigationConfig';

export default function Navigation({ scrollProgress = 0 }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <nav className="relative">
      {/* Desktop Navigation */}
      <div className="hidden md:flex items-center space-x-1">
        {navigationLinks.map(link => (
          <NavigationLink 
            key={link.to} 
            to={link.to}
            scrollProgress={scrollProgress}
          >
            {link.label}
          </NavigationLink>
        ))}
        <RentalButton scrollProgress={scrollProgress} />
      </div>

      {/* Mobile Navigation */}
      <div className="md:hidden">
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="p-2 rounded-lg hover:bg-red-50 transition-colors"
        >
          <motion.div
            initial={false}
            animate={{ rotate: isMobileMenuOpen ? 180 : 0 }}
          >
            {isMobileMenuOpen ? (
              <FiX className="w-6 h-6" />
            ) : (
              <FiMenu className="w-6 h-6" />
            )}
          </motion.div>
        </button>
        <MobileMenu 
          isOpen={isMobileMenuOpen} 
          onClose={() => setIsMobileMenuOpen(false)}
          scrollProgress={scrollProgress}
        />
      </div>
    </nav>
  );
}